<template>
  <div class="cart-container">
    <CartCart class="cart" v-if="stock_cart.length"
              v-for="(cart, index) in stock_cart" :cart="cart" :key="'cart_'+index">
    </CartCart>
    <div class="message" v-if="stock_cart.length === 0">
      カートはからです
      <button @click="$router.push({name:'category'})">TOPへ</button>
    </div>
    <div class="footer">
      <div class="footer-container">
        <div class="price">合計 {{ cartStockTotalPrice | currency }}</div>
        <div class="buttons">
          <button @click="cartReset">戻る</button>
          <button @click="$router.push({name:'orderInput'})">次へ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import CartCart from './cart/Cart.vue'

  export default {
    name: 'Cart',
    components: {
      CartCart
    },
    computed: {
      ...mapGetters([
        'cartStockTotalPrice',
      ]),
      stock_cart() {
        return this.$store.state.stock_cart;
      },
    },
    methods: {
      cartReset () {
        this.$store.commit('resetCart');
        this.$router.push({name: 'category'});
      }
    }
  }
</script>

<style lang="scss" scoped>
  .cart {
    border: 1px solid black;
    overflow: auto;
  }
  .message {
    padding: 1rem;
  }
  .cart-container {
    margin-bottom: 4rem;
  }
  .footer {
    color: #fff;
    background-color: #151d66;
    position: fixed;
    width: 100%;
    bottom: 0;
    z-index: 101;
    .footer-container {
      padding: 5px;
      .price {
        text-align: right;
      }
      .buttons {
        display: flex;
        flex-wrap: wrap;
        button {
          flex-grow: 1;
        }
      }
    }
  }
</style>
